import { EventEmitter, Injectable, Output } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { AssigneeModalComponent } from 'src/app/shared/modals/assignee-modal/assignee-modal.component';
import { UserBaseModel } from '../../models/members/user/user-base.model';
import { RequisitionModel } from '../../models/requisition/requisition.model';

@Injectable({
    providedIn: 'root'
})
export class AssigneesModalService {

    @Output() modelChanged = new EventEmitter<any>();

    constructor(private modalService: NgbModal) { }

    openModal(assigneesList: UserBaseModel[] | undefined, assigneeIds: string[] | undefined, updateOnUpdate?: boolean, requisitionModel?: RequisitionModel) {
        var modalRef!: NgbModalRef;
        modalRef = this.modalService.open(AssigneeModalComponent, { windowClass: "myCustomModalClassUnderTopBar", size: 'md', centered: false, backdrop: 'static', keyboard: false, scrollable: true });

        modalRef.componentInstance.updateOnUpdate = updateOnUpdate;
        modalRef.componentInstance.requisitionModel = requisitionModel;
        
        if (assigneesList != undefined) {
            modalRef.componentInstance.assigneesList = [...assigneesList];         // need to put a structuredClone here to avoid a shallow copy and not just a pointer to each other. 
        } else {
            modalRef.componentInstance.assigneesList = undefined;
        }

        if (assigneeIds != undefined) {
            modalRef.componentInstance.assigneeIds = [...assigneeIds];         // need to put a structuredClone here to avoid a shallow copy and not just a pointer to each other. 
        } else {
            modalRef.componentInstance.assigneeIds = undefined;
        }


        var sub: Subscription = modalRef.closed.subscribe(() => {
            var emit: { assigneesList: UserBaseModel[] | undefined, assigneeIds: string[] | undefined, changed: boolean } = { assigneesList: modalRef.componentInstance.assigneesList, assigneeIds: modalRef.componentInstance.assigneeIds, changed: modalRef.componentInstance.modelChanged };
            this.modelChanged.emit(emit);
            sub.unsubscribe();
        })
    }

    openModalWithBatchEditing() {
        var modalRef!: NgbModalRef;
        modalRef = this.modalService.open(AssigneeModalComponent, { windowClass: "myCustomModalClassUnderTopBar", size: 'md', centered: false, backdrop: 'static', keyboard: false, scrollable: true });
        
        modalRef.componentInstance.assigneesList = undefined;
      
        modalRef.componentInstance.assigneeIds = undefined;

        var sub: Subscription = modalRef.closed.subscribe(() => {
            var emit: { assigneesList: UserBaseModel[] | undefined, assigneeIds: string[] | undefined, changed: boolean } = { assigneesList: modalRef.componentInstance.assigneesList, assigneeIds: modalRef.componentInstance.assigneeIds, changed: modalRef.componentInstance.modelChanged };
            this.modelChanged.emit(emit);
            sub.unsubscribe();
        })
    }
}
